import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, EventEmitter, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicFormsService } from '../services/dynamic-forms.service';
import { ActivatedRoute } from '@angular/router';
import { HTTPService } from '../services/http.service';
import { MatPaginator } from '@angular/material/paginator';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';

import { trigger, style, animate, transition ,query} from '@angular/animations';
import { DatatableComponent, TableColumn } from '@swimlane/ngx-datatable';

import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { columnsDef } from '../interfaces/columnsDef';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dynamic-forms',
    templateUrl: './dynamic-forms.component.html',
    styleUrls: ['./dynamic-forms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DynamicFormsService],
    animations: [
        trigger('enterAnimation', [
            transition('* => *', [
                query(':enter', [
                    style({ opacity: 0 })
                ], { optional: true }),
                query(':leave', [
                    style({ opacity: 0 }),
                    animate('0.1s', style({ opacity: 0 }))
                ], { optional: true }),
                query(':enter', [
                    style({ opacity: 0 }),
                    animate('0.5s', style({ opacity: 2 }))
                ], { optional: true })
            ])
        ])
    ],
    standalone: false
})


export class DynamicFormsComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {read: true}) sort: MatSort;
  @ViewChild('dynamicTable') dynamicTable: DatatableComponent;
  @ViewChild('loadingDiv') loadingDiv:ElementRef;

  
  @Input("inputEntityName") inputEntityName:string;  
  @Input("inputTableName") inputTableName:string;
  @Input("child") child:Boolean = false;
  @Input("filterExpression") filterExpression:string;
  @Input("fatherFilterExpression") fatherFilterExpression:string;
  @Input("fatherdata") fatherdata:Object;
  
  public table_name:String = "";
  public entityDesc:String = "";
  public selected = [];
  public _dynaServices:DynamicFormsService;
  public rawEvent: any;
  public contextmenuRow: any;
  public contextmenuColumn: any;
  public filtroStr:String = "Nenhum campo selecionada para filtro."
  public userId:number = 1;
  public rows:Object[];
  public tabs:String[];
  customAction: any[];
  sub:Subscription;

  constructor(private dynaServices:DynamicFormsService,  private snackBar: MatSnackBar, private routerParam:ActivatedRoute, private  http: HTTPService,private cd: ChangeDetectorRef,
    private el: ElementRef ) { 
  
    this.userId = 1;
    this._dynaServices = dynaServices;  
    this._dynaServices.cd  = cd;
    this._dynaServices.gridMode = true;
    this._dynaServices.loadingIndicator = true;
    this._dynaServices.el = el;
    this._dynaServices.pageLimit =20;
    this._dynaServices.headerHeight = 50;
    this._dynaServices.rowHeight = 50;
    this._dynaServices.userId = this.userId;
    
  }

  ngOnDestroy(){
    if (this.sub!= null ) {this.sub.unsubscribe();}
  }
  
  initialize(){
    
    if (this.child){
      this.tabs = [];
    }else{
      this.tabs =this._dynaServices.tabs;
      this.table_name = this.routerParam.snapshot.data["table_name"];
      this.entityDesc = this.routerParam.snapshot.data["entityDesc"];
      this.customAction = this.routerParam.snapshot.data["customAction"];
      
    }
  
    this._dynaServices.dynamicTable = this.dynamicTable;
    this._dynaServices.entityName = this.table_name;
    this._dynaServices.rows = [];
    this._dynaServices.filterExpression = "";
    this._dynaServices.displayedColumns = [];
    this._dynaServices.enabledColumns = [];
    this._dynaServices.availableColumns = [];
    this.sub = this._dynaServices.loadUserConfig().subscribe(data=>{
          if ( data["Mktpusercfg"].length === 0 ){
            this._dynaServices.userConfig = null;
          }else{
            this._dynaServices.userConfig = data["Mktpusercfg"][0];
          }
          if ( this.child ){
              this._dynaServices.childFilterExpression = this.fatherFilterExpression;
              this.dynaServices.ischild = true;
              this.dynaServices.fatherData = this.fatherdata;
        
          }
          this._dynaServices.fetch(0,this.child);
          
      },
    );
  }

  ngAfterViewInit(): void {
    
    this.initialize();
    
  }

  ngOnInit() {

      if ( this.child ){
        this.table_name = this.inputTableName;
        this.entityDesc = this.inputEntityName;  
        this._dynaServices.filterExpression = this.fatherFilterExpression;
      }else{
        this.table_name = this.routerParam.snapshot.data["table_name"];
        this.entityDesc = this.routerParam.snapshot.data["entityDesc"];
      }

  }

  

  onTableContextMenu(contextMenuEvent) {

    this.rawEvent = contextMenuEvent.event;
    if (contextMenuEvent.type === 'body') {
      this.contextmenuRow = contextMenuEvent.content;
      this.contextmenuColumn = undefined;
      this.filtroStr = `Nenhum campo selecionada para filtro.`;
    } else {
      this.contextmenuColumn = contextMenuEvent.content;
      this.filtroStr = `Campo ${this.contextmenuColumn.name} selecionado para filtro.`;
      this.contextmenuRow = undefined;
    }

    contextMenuEvent.event.preventDefault();
    contextMenuEvent.event.stopPropagation();
  }

  
  private delay(ms: number): Promise<boolean> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, ms);
    });
  }

  eventGrid( event:EventEmitter<Object>) {
      let type:String = event['type'];
      let eventType:Event = event['event'];
      let row:Object = event['row'];

      if ( this._dynaServices == null ){
        return;
      }
      
      if ( type == "dblclick"){
        this._dynaServices.changeFace();
        this._dynaServices.selectedRow = [];
        this._dynaServices.selectedRow.push(row as columnsDef);
        this.fatherFilterExpression = row['filterExpression'];
      }

      if ( type == "click"){ 
        this._dynaServices.selectedRow = [];
        this.dynamicTable.selected.forEach(x =>{
          this._dynaServices.selectedRow.push(x as columnsDef);
          this.fatherFilterExpression = x['filterExpression'];
        });

        
      }

      if ( type == "mouseenter"){
        return;
      }
  }
  updateFilter(event) {
    
    if ( this.contextmenuColumn == undefined ){
      this.snackBar.open("Clicar na coluna que deseja filtrar com o botão direito do mouse.",null,{duration:3000});
      return;
    }
    
    
    const val = event.target.value.toLowerCase();
    let columnName:string = this.contextmenuColumn.prop;
    
    // filter our data
    const temp = this.dynaServices.temp.filter(function(d) {
      return d[columnName].toString().toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this._dynaServices.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this._dynaServices.dynamicTable.offset = 0;
    
  }

  public onReoder(column:TableColumn, newValue:any, prevValue:any):void{
    this._dynaServices.loadingIndicator = true;

    let jsonOb:JSON = null;
    try{
        jsonOb = JSON.parse(this._dynaServices.userConfig['CONFIG']);
    }catch ( e ){
        jsonOb = this._dynaServices.userConfig['CONFIG'];
    }

    let config:Array<Object> =  jsonOb['datagrid']['enableColumns']
    let ob:Object = config.find(x => x['columnName'] == column.prop );
    let ob2:Object = config.find(x => x['columnGridOrder'] == newValue+1 );
    ob["columnGridOrder"]  = newValue+1;
    ob2["columnGridOrder"] = prevValue+1;

    this._dynaServices.userConfig['CONFIG'] = JSON.stringify({ 'datagrid': {'enableColumns':config}});

    let jsonDec:Object ={
      "entityName":"Mktpdic",
      "condition":`instancename='${this.table_name}'`
    };

    this.dynaServices.saveUserCfg(jsonDec);
  }


  public onResize(column:TableColumn, newValue:any):void{
    
    if ( ObjectUtil.isNotEmpty(this._dynaServices.userConfig && ObjectUtil.isNotEmpty(column) ) ){
      this._dynaServices.loadingIndicator = true;

      let jsonOb:JSON = null;
      try{
          jsonOb = JSON.parse(this._dynaServices.userConfig['CONFIG']);
      }catch ( e ){
          jsonOb = this._dynaServices.userConfig['CONFIG'];
      }
      
      let config:Array<Object> =  jsonOb['datagrid']['enableColumns']
      let ob:Object = config.find(x => x['columnName'] == column.prop );
      ob['columnGridSize'] = newValue;
      this._dynaServices.userConfig['CONFIG'] = JSON.stringify({ 'datagrid': {'enableColumns':config}});

      let jsonDec:Object ={
        "entityName":"Mktpdic",
        "condition":`instancename='${this.table_name}'`
      };

      this.dynaServices.saveUserCfg(jsonDec);
    }
    

  }


  formSubmitted(value) {
    /*if (this._dynaServices.selectedRow.indexOf(value) == -1){
      this._dynaServices.selectedRow.push(value);
    } habilitar isso quando tiver algum submit que precisamos analisar, nessa parte podemso fazer validação de formularios.*/
    
  }

 
}
